export default __webpack_public_path__ + "static/media/fox@3x.ea25e1e7.png";